import React from "react";
import getClassNameFactory from "../../../../utilities/classNames";
import UiIconSmallRight from "@dcl/icons/esm/ui/small-right";
import InlineErrorMessage from "../../../../elements/InlineErrorMessage";
import Dropdown from "../../../../modules/Dropdown";
import FlexGrid from "../../../../modules/FlexGrid";
import HorizontalRule from "../../../../elements/HorizontalRule";
import { GO_STRING, GO_TO_PAGE_STRING, OF_STRING, TO_STRING } from "../../constants";
export var DynamicPaginationMobile = function DynamicPaginationMobile(_ref) {
  var currentPage = _ref.currentPage,
      viewingLabelContent = _ref.viewingLabelContent,
      rowsPerPageLabelContent = _ref.rowsPerPageLabelContent,
      isInvalidPageNum = _ref.isInvalidPageNum,
      canPreviousPage = _ref.canPreviousPage,
      canNextPage = _ref.canNextPage,
      goToPageNum = _ref.goToPageNum,
      viewFrom = _ref.viewFrom,
      viewTo = _ref.viewTo,
      previousButtonLabel = _ref.previousButtonLabel,
      nextButtonLabel = _ref.nextButtonLabel,
      paginationLabel = _ref.paginationLabel,
      totalPages = _ref.totalPages,
      totalItems = _ref.totalItems,
      pageSize = _ref.pageSize,
      rowsPerPageLabel = _ref.rowsPerPageLabel,
      rowsPerPageOptions = _ref.rowsPerPageOptions,
      goToPageError = _ref.goToPageError,
      handlePageSizeChange = _ref.handlePageSizeChange,
      handleGoToPage = _ref.handleGoToPage,
      handleKeyDown = _ref.handleKeyDown,
      handlePageChange = _ref.handlePageChange;
  var getClassName = getClassNameFactory(DynamicPaginationMobile.displayName);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FlexGrid.Row, {
    className: getClassName()
  }, /*#__PURE__*/React.createElement(FlexGrid.Col, {
    xs: 12,
    sm: 12,
    md: 12,
    className: getClassName({
      descendantName: "viewing"
    })
  }, viewingLabelContent, " ", /*#__PURE__*/React.createElement("b", null, currentPage), " ", OF_STRING, " ", /*#__PURE__*/React.createElement("b", null, totalPages))), /*#__PURE__*/React.createElement(FlexGrid.Row, {
    className: getClassName({
      descendantName: "pageNavigationRow"
    })
  }, /*#__PURE__*/React.createElement(FlexGrid.Col, {
    xs: 6,
    sm: 6,
    md: 6,
    className: getClassName({
      descendantName: "previousButton"
    })
  }, /*#__PURE__*/React.createElement("nav", {
    role: "navigation",
    "aria-label": paginationLabel,
    className: getClassName({
      descendantName: "pagination",
      modifiers: isInvalidPageNum && "error"
    })
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return handlePageChange(currentPage - 1);
    },
    className: getClassName({
      descendantName: "button",
      modifiers: "previous"
    }),
    disabled: !canPreviousPage
  }, /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "buttonIcon",
      modifiers: !canPreviousPage && "disabled"
    })
  }, /*#__PURE__*/React.createElement(UiIconSmallRight, {
    width: 24
  })), /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "buttonLabel"
    })
  }, previousButtonLabel)))), /*#__PURE__*/React.createElement(FlexGrid.Col, {
    xs: 6,
    sm: 6,
    md: 6,
    className: getClassName({
      descendantName: "nextButton"
    })
  }, /*#__PURE__*/React.createElement("nav", {
    role: "navigation",
    "aria-label": paginationLabel,
    className: getClassName({
      descendantName: "pagination",
      modifiers: isInvalidPageNum && "error"
    })
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return handlePageChange(currentPage + 1);
    },
    className: getClassName({
      descendantName: "button",
      modifiers: "next"
    }),
    disabled: !canNextPage
  }, /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "buttonLabel"
    })
  }, nextButtonLabel), /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "buttonIcon",
      modifiers: !canNextPage && "disabled"
    })
  }, /*#__PURE__*/React.createElement(UiIconSmallRight, {
    width: 24
  })))))), /*#__PURE__*/React.createElement(FlexGrid.Row, {
    className: getClassName()
  }, /*#__PURE__*/React.createElement(FlexGrid.Col, {
    xs: 12,
    sm: 12,
    md: 12,
    className: getClassName({
      descendantName: "horizontalDivider"
    })
  }, /*#__PURE__*/React.createElement(HorizontalRule, null))), /*#__PURE__*/React.createElement(FlexGrid.Row, {
    className: getClassName()
  }, /*#__PURE__*/React.createElement(FlexGrid.Col, {
    xs: 12,
    sm: 12,
    md: 12,
    className: getClassName({
      descendantName: "dropdownWrapper",
      modifiers: "label"
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "pageSizeLabel"
    })
  }, "(".concat(rowsPerPageLabelContent), " ", /*#__PURE__*/React.createElement("b", null, viewFrom), " ", TO_STRING, " ", /*#__PURE__*/React.createElement("b", null, viewTo), " ", OF_STRING, " ", /*#__PURE__*/React.createElement("b", null, totalItems), ")"))), /*#__PURE__*/React.createElement(FlexGrid.Row, {
    className: getClassName()
  }, /*#__PURE__*/React.createElement(FlexGrid.Col, {
    xs: 6,
    sm: 6,
    md: 6,
    className: getClassName({
      descendantName: "goToPageLabel"
    })
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "goToPageNumberInput",
    className: getClassName({
      descendantName: "inputLabel"
    })
  }, GO_TO_PAGE_STRING)), /*#__PURE__*/React.createElement(FlexGrid.Col, {
    xs: 6,
    sm: 6,
    md: 6,
    className: getClassName({
      descendantName: "dropdownWrapper"
    })
  }, rowsPerPageLabel)), /*#__PURE__*/React.createElement(FlexGrid.Row, {
    className: getClassName({
      descendantName: "pageRowWrapper"
    })
  }, /*#__PURE__*/React.createElement(FlexGrid.Col, {
    xs: 6,
    sm: 6,
    md: 6,
    className: getClassName({
      descendantName: "goToPageWrapper"
    })
  }, /*#__PURE__*/React.createElement("nav", {
    role: "navigation",
    "aria-label": paginationLabel,
    className: getClassName({
      descendantName: "paginationGoTo"
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "goToPage"
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "inputWrapper"
    })
  }, /*#__PURE__*/React.createElement("input", {
    className: getClassName({
      descendantName: "input",
      modifiers: isInvalidPageNum && "error"
    }),
    id: "goToPageNumberInput",
    type: "number",
    onChange: handleGoToPage,
    onKeyDown: handleKeyDown,
    inputMode: "numeric",
    value: goToPageNum || ""
  }), isInvalidPageNum && /*#__PURE__*/React.createElement(InlineErrorMessage, {
    id: "error",
    className: getClassName({
      descendantName: "error"
    }),
    errorMessage: goToPageError
  }))), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return handlePageChange(goToPageNum);
    },
    className: getClassName({
      descendantName: "button",
      modifiers: "go"
    }),
    disabled: isInvalidPageNum
  }, GO_STRING))), /*#__PURE__*/React.createElement(FlexGrid.Col, {
    xs: 6,
    sm: 6,
    md: 6,
    className: getClassName({
      descendantName: "dropdownWrapper"
    })
  }, /*#__PURE__*/React.createElement("div", {
    id: "rows-per-page-label",
    className: getClassName({
      descendantName: "pageSize"
    })
  }, /*#__PURE__*/React.createElement(Dropdown, {
    labeledBy: "rows-per-page-label",
    items: rowsPerPageOptions,
    placeholder: "",
    onValueChanged: handlePageSizeChange,
    size: "small",
    value: pageSize,
    withCheckmark: true
  })))));
};
DynamicPaginationMobile.displayName = "DynamicPaginationSaf";